import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-393b1854"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "info-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "section-title"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.signUpFields)
      ? (_openBlock(), _createBlock($setup["Form"], { key: 0 }, {
          default: _withCtx(({ meta }) => [
            _createElementVNode("fieldset", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.arrangedSignUpFields, (field, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (field.type === 'label')
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(field.label), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode($setup["DynamicFormField"], {
                          field: field,
                          value: $setup.getFieldValue(field.inputFields),
                          parentValue: $setup.getParentFieldValue(field),
                          "onUpdate:value": ($event: any) => ($setup.updateValue(field, $event)),
                          disabled: field.isAutoFilledForJoin || !field.isValid,
                          required: field.isRequired,
                          rankCode: $props.rankCode,
                          rules: $setup.getRules(field),
                          onUpdateChildTimerStatus: ($event: any) => ($setup.updateChildTimerStatus(field, $event))
                        }, null, 8 /* PROPS */, ["field", "value", "parentValue", "onUpdate:value", "disabled", "required", "rankCode", "rules", "onUpdateChildTimerStatus"])
                      ]))
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createVNode($setup["BaseButton"], {
              class: "btn-signup",
              title: "회원가입",
              disabled: !meta.valid || $setup.hasUnverifiedFields(),
              onClick: $setup.onClickSignupButton
            }, null, 8 /* PROPS */, ["disabled"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}